const fundView_ColumnDefs = [
  {
    headerName: 'Code',
    field: 'fundCode',
    width: 140,
  },
  { headerName: 'Desc', field: 'fundDesc', width: 300 },
  { headerName: 'Currency', field: 'baseCurrencyCode', width: 110 },
  { headerName: 'Country', field: 'countryCode', width: 110 },
  {
    headerName: 'IsPlatform',
    field: 'isPlatform',
    width: 90,
    cellDataType: 'boolean',
  },
  {
    headerName: 'IsActive',
    field: 'isActive',
    width: 90,
    cellDataType: 'boolean',
  },
  { headerName: 'IsReal', field: 'isReal', width: 90, cellDataType: 'boolean' },
  {
    headerName: 'UseNewAcct',
    field: 'useNewAcct',
    width: 90,
    cellDataType: 'boolean',
  },
  { headerName: 'CreatedBy', field: 'createdBy', width: 140 },
  { headerName: 'CreatedOn', field: 'createdOn', width: 160 },
  { headerName: 'LastModifiedBy', field: 'lastModifiedBy', width: 140 },
  { headerName: 'LastModifiedOn', field: 'lastModifiedOn', width: 160 },
  {
    headerName: 'Action',
    field: 'edit',
    width: 80,
    filter: false,
    cellRenderer: 'AgEditCellRenderer',
    cellRendererParams: {
      fn: () => {},
    },
  },
]

export default fundView_ColumnDefs
